/**
 * @readonly
 * @typedef {string} incidentClientDisplayOption
 * @enum {incidentClientDisplayOption}
 */
export const IncidentClientDisplayOption = {
    NEVER: 'never',
    PRE_LOGIN: 'pre_login',
    POST_LOGIN: 'post_login',
    ALWAYS: 'always'
}
